import { render, staticRenderFns } from "./LiabilitiesSection.vue?vue&type=template&id=a1c295ee&"
import script from "./LiabilitiesSection.vue?vue&type=script&lang=js&"
export * from "./LiabilitiesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
